'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateFields = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _object = require('helpers/object');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validateFields = exports.validateFields = function validateFields(validator, fieldNames) {
  return function (formData) {
    return (0, _object.fromEntries)(fieldNames.map(function (fieldName) {
      return [fieldName, validator(formData[fieldName], formData)];
    }).filter(function (_ref) {
      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
          errorMessage = _ref2[1];

      return !!errorMessage;
    }));
  };
};